import { autoAddRemoveBy } from "../../cpcoc/autoAddRemoveBy";
import { addSlide } from "./addSlide";
import { handleObjProps } from "./handleObjProps";
import { setColorBG } from "./setColorBG";
export function createSlide(slide, id) {
    // TODO: use dataset instead of setAttribute?
    const section = document.createElement("section");
    section.id = id;
    if (typeof slide === "string") {
        section.innerHTML = slide || "";
        addSlide(section);
    }
    else {
        const center = slide.center || true;
        const wrap = slide.wrap || true;
        let html = slide.html || "";
        // TODO: Fix this weird condition
        html =
            String(wrap).toLowerCase() === "false"
                ? html
                : `<div>${html}</div>`;
        if (slide.type === "markdown") {
            section.setAttribute("data-markdown", "");
            section.innerHTML = `<textarea data-template>${html}</textarea>`;
        }
        else {
            section.innerHTML = html;
        }
        if (slide.classList) {
            section.setAttribute("class", slide.classList);
        }
        if (String(center).toLowerCase() !== "false") {
            // TODO: Fix this weird condition
            section.classList.add("center");
        }
        if (slide.transition) {
            handleObjProps("transition", slide.transition, section);
        }
        if (slide.fontSize) {
            section.style.fontSize = slide.fontSize;
        }
        if (slide.background) {
            handleObjProps("background", slide.background, section);
        }
        else {
            setColorBG(section, null);
        }
        if (slide.frame) {
            section.innerHTML += '<div class="frame standalone"></div>';
        }
        if (slide.autoslide) {
            section.setAttribute("data-autoslide", String(slide.autoslide));
        }
        if (slide.autoanimate) {
            section.setAttribute("data-auto-animate", "true");
        }
        if (slide.timeState) {
            section.setAttribute("data-time-state", slide.timeState);
        }
        else {
            section.setAttribute("data-time-state", "default");
        }
        autoAddRemoveBy(slide.startDate, slide.endDate, () => addSlide(section, slide.placement));
    }
}
